<template>
    <app-table
        clickable
        :data="tvStations"
        :highlight-rows-on-hover="true"
        @rowClick="goToDetail"
    >
        <app-table-column first :label="translations.name">
            <template slot-scope="row">
                <strong>
                    {{ row.name }}
                </strong>
            </template>
        </app-table-column>
        <app-table-column :label="translations.importId">
            <template slot-scope="row">
                {{ row.importId }}
            </template>
        </app-table-column>
        <app-table-column :label="translations.type">
            <template slot-scope="row">
                {{ getTvStationType(row.type) }}
            </template>
        </app-table-column>
        <app-table-column :label="translations.streamingType">
            <template slot-scope="row">
                {{ getTvStationStreamingType(row.streamingType) }}
            </template>
        </app-table-column>
    </app-table>
</template>

<script>
import formatDateMixin from 'mixins/formatDateMixin'

export default {
    name: 'maturity-rating-tv-stations',
    mixins: [formatDateMixin],
    props: ["tvStations"],
    methods: {
        goToDetail(item) {
            this.$router.push({
                name: 'tv-station',
                params: {
                    id: item._id
                }
            });
        },
        getTvStationType(type) {
            for (let item of this.enums.tvStationType) {
                if (item.value === type) {
                    return item.name;
                }
            }
        },
        getTvStationStreamingType(type) {
            for (let item of this.enums.tvStationStreamingType) {
                if (item.value === type) {
                    return item.name;
                }
            }
        }
    },
    computed: {
        enums() {
            return this.$store.state.enums.enums;
        },
        translations() {
          return {
            name: this.$gettext('Název'),
            importId: this.$gettext('Importní ID'),
            type: this.$gettext('Typ'),
            streamingType: this.$gettext('Typ vysílání')
        }
    },
  },
}
</script>
